import React, {useEffect, useRef, useState} from "react";
import {HelpHttp} from "helpers/HelpHttp";
import LineCrudTable from "./LineCrudTable";
import LineCrudTableForm from "./LineCrudTableForm";
import LineCrudTableSearch from "./LineCrudTableSearch";
//modal
import LineCrudTableSearchModal from "./LineCrudTableSearchModal";
import LineCrudTableModal from "./LineCrudTableModal";
import LineCrudTableModal2 from "./LineCrudTableModal2";

import SpinnerBootrap from "components/SpinnerBootrap";
import RequestError from "components/RequestError";
import Swal from "sweetalert2";
import {Modal} from "react-bootstrap";


const {REACT_APP_API} = process.env;
const initialForm = {_id: null, documentClient: '', number: '', type: '', numeroReportes: 0};

let amountLinesPages = 0;
let amountLines = 0;
let amountLinesPerPage = 5;

let amountClientsPages = 0;
let amountClients = 0;
let amountClientsPerPage = 5;

const LineCrud = () => {
    const [, setFindModal] = useState(null);
    const [lines, setLines] = useState(null);
    const [find, setFind] = useState(null);
    const [dataToEdit, setDataToEdit] = useState(null);
    const [form, setForm] = useState(initialForm);
    const [requestError, setRequestError] = useState(null);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [numberPageLine, setNumberPageLine] = useState(1);
    const [numberPageClient, setNumberPageClient] = useState(1);
    //For Modal
    //general
    const [LineSelected, setIdforLine] = useState(null);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    //segmento 2
    const [clients, setClients] = useState(null);
    const [ListClientsWhitLine, setListClientsWhitLine] = useState(null);
    const [itemsPerPage, setItemsPerPage] = useState(amountLinesPerPage);
    const [hasSearch, setHasSearch] = useState(false);
    const searchFormRef = useRef();

    const resetSearch = () => {
        setHasSearch(false);
        searchFormRef?.current?.reset();
    }

    let api = HelpHttp();
    let url = `${REACT_APP_API}/lines`

    

    const validateInputOfSearch = () => {
        Swal.fire({
            title: 'Seleccione una opción de busqueda.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        })  
    }
    const openModalVinculetedAlreadyExists = () => {
        Swal.fire({
            title: 'Una linea solo se puede vincular a un cliente, desvincule al cliente actual.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        })  
    }
    const editData = (el) => {
        setDataToEdit(el);
        setErrors(null);
    }

    const getAmountLines = () => {
        setLoading(true);
        api.get(url).then(res => {
            if (res.err) {
            } else {
                amountLines = res.length;
                amountLinesPages = Math.ceil(amountLines / itemsPerPage);
                listLines(numberPageLine)
            }
        });

    }

    const listLines = (numberPage = 1, limit = itemsPerPage ) => {
        setLoading(true);
        setNumberPageLine(numberPage)
        amountLinesPages = Math.ceil(amountLines / limit);
        api.get(`${url}/?page=${numberPage}&limit=${limit}`).then(res => {
            if (res.err) {
                setLines(null);
                setRequestError(res);
            } else {
                setLines(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }


    const desvinculedClient = (el) => {
        console.log("id de linea seleccionada : "+LineSelected._id);
        let LineSelectedLocal = LineSelected;
        LineSelectedLocal.documentClient="";

        let endPoint = `${url}/${LineSelectedLocal._id}`;
        let options = {body: LineSelectedLocal, headers: {'content-type': 'application/json'}};
        api.put(endPoint, options).then(res => {
            console.log(res);
            if (res.err) {
                //console.log(lines);
                setRequestError(res);
            } else {
                if (res.status) {
                    //listLines(); llamar nuvamente a la slita de lclientes viculados a esta linea
                    listClientsByNumberLine()
                    getAmountLines();
                    getAmountClientsWhitoutLine();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const vinculedClient = (numDocument) => {               //para modal segmento 2
        //console.log("id de linea seleccionada : "+LineSelected._id);
        //console.log("linea original");
        //console.log(LineSelected);
        let LineSelectedLocal = LineSelected;
        LineSelectedLocal.documentClient=numDocument;
        //console.log("linea modificada");
        //console.log(LineSelectedLocal);
        let endPoint = `${url}/${LineSelectedLocal._id}`;
        let options = {body: LineSelectedLocal, headers: {'content-type': 'application/json'}};
        api.put(endPoint, options).then(res => {
            console.log(res);
            if (res.err) {
                //console.log(lines);
                setRequestError(res);
            } else {
                if (res.status) {
                    listClientsByNumberLine(numDocument)
                    getAmountLines();
                    getAmountClientsWhitoutLine();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }

    const getAmountClientsWhitoutLine = () => {
        setLoading(true);
        let urlLine = `${REACT_APP_API}/clients/findAllWhitoutLine`
        api.get(urlLine).then(res => {
            if (res.err) {
            } else {
                amountClients = res.length;
                amountClientsPages = Math.ceil(amountClients / amountClientsPerPage);
                listClientsWhitoutLine(numberPageClient)
            }
        });
    }

    const listClientsWhitoutLine = (numberPage = 1) => {
        setLoading(true);
        setNumberPageClient(numberPage)
        let url = `${REACT_APP_API}/clients/findAllWhitoutLine/?page=${numberPage}&limit=${amountLinesPerPage}`
        api.get(url).then(res => {
            if (res.err) {
                setClients(null);
                setRequestError(res);
            } else {
                setClients(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }
    
    // const listClientsAll = () => {                          //para modal segmento 2
    //     let url = `${REACT_APP_API}/clients`                //me trae todos los clientes con su cantidad de lineas vinculadas
    //     setLoading(true);
    //     api.get(url).then(res => {
    //         if (res.err) {
    //             setClients(null);
    //             setRequestError(res);
    //         } else {
    //             setClients(res);
    //             console.log(res);
    //             setRequestError(null);
    //         }
    //         setLoading(false);
    //     });
    // }

    const listClientsByNumberLine = (numDocument) => {
        let url = `${REACT_APP_API}/clients/findByNumberDocument/?numDocument=${numDocument}`

        setLoading(true);
        api.get(url).then(res => {
            if (res.err) {
                setListClientsWhitLine(null);
                setRequestError(res);
            } else {
                setListClientsWhitLine(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }

    const listClientsByNumDocument = (valueInput) => {
         if (valueInput === "") {
            Swal.fire({
                title: 'Ingrese un número de documento',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        }else {
            let url = `${REACT_APP_API}/clients/findAllWhitoutLine/?numDocument=${valueInput}`
            setLoading(true);
            api.get(url).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    //console.log("tamaño : "+res.length);
                    setClients(res);
                    setRequestError(null);
                }
                setLoading(false);
            });  
        }
    }
    const listClientsByMail = (valueInput) => {
        if (valueInput === "") {
            Swal.fire({
                title: 'Ingrese un correo',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            let url = `${REACT_APP_API}/clients`
            const endPoint = `${url}/findByMail/?mail=${valueInput}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    setClients(res);
                    setRequestError(null);
                }
                setLoading(false);
            });
        }
    }
    const listClientsByName = (valueInput) => {
        if (valueInput === "") {
            Swal.fire({
                title: 'Ingrese un nombre',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            let url = `${REACT_APP_API}/clients/findAllWhitoutLine/?name=${valueInput}`

            setLoading(true);
            api.get(url).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    setClients(res);
                    setRequestError(null);
                }
                setLoading(false);
            });
        }
    
    }
    const listLinesByNumberLine = () => { // home
        console.log(find);
        //console.log(find.find);

        if (find === null || find.find === "") {
            Swal.fire({
                title: 'Ingrese un Número de Línea',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            const endPoint = `${url}/findAllByNumber/?number=${find.find}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setLines(null);
                    setRequestError(res);
                } else {
                    amountLinesPages = Math.ceil(amountLines / itemsPerPage);
                    setLines(res);
                    console.log(endPoint);
                    console.log(find.find);
                    console.log(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });
        }
    }
    const listLinesByNumberDocumentOfClient = () => { // home
        console.log(find);
        //console.log(find.find);
        if (find === null || find.find === "") {
            Swal.fire({
                title: 'Ingrese un número de documento de Cliente',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            //http://localhost:7400/api/lines/findByDocumentClient/?documentClient=74199853
            const endPoint = `${url}/findByDocumentClient/?documentClient=${find.find}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setLines(null);
                    setRequestError(res);
                } else {
                    amountLinesPages = Math.ceil(amountLines / itemsPerPage);
                    setLines(res);
                    console.log(endPoint);
                    console.log(find.find);
                    console.log(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });
        }
    }
    const createData = (data) => {
        let options = {body: data, headers: {'content-type': 'application/json'}};
        api.post(url, options).then(res => {
            console.log(res);
            if (res.err) {
                setRequestError(res);
            } else {
                if (res.status) {
                    getAmountLines();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const updateData = (data) => {
        //console.lo(data);
        let endPoint = `${url}/${data._id}`;
        let options = {body: data, headers: {'content-type': 'application/json'}};
        api.put(endPoint, options).then(res => {
            console.log(res);
            if (res.err) {
                console.log(lines);
                setRequestError(res);
            } else {
                if (res.status) {
                    getAmountLines();
                    handleReset();
                    Swal.fire('¡Ok!', res.message, 'success');
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const deleteData = (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, bórralo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                const endPoint = `${url}/${id}`;
                let options = {headers: {'content-type': 'application/json'}};
                api.del(endPoint, options).then(res => {
                    console.log(res);
                    if (res.err) {
                        setRequestError(res);
                    } else {
                        if (res.status) {
                            Swal.fire('¡Eliminado!', res.message, 'success');
                            getAmountLines();
                            // handleReset();
                        } else {
                            setErrors(res.errors);
                        }
                    }
                });
            }
        });
    }
    const handleReset = (e) => {
        setErrors(null);
        setForm(initialForm);
        setDataToEdit(null);
    }

    useEffect(() => {
        if (dataToEdit) {
            setForm(dataToEdit)
        } else {
            setForm(initialForm);
        }
    }, [dataToEdit]);

    useEffect(() => {
        getAmountLines();
        getAmountClientsWhitoutLine();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="container">
            <div className="row my-md-4">
                <h4 className="d-flex justify-content-center">Mantenedor de Líneas</h4>
                {requestError && <RequestError msg={requestError}/>}
                <div className="col-12">
                    <LineCrudTableSearch 
                        setFind={setFind} 
                        listLinesByNumberLine={listLinesByNumberLine}
                        listLinesByNumberDocumentOfClient={listLinesByNumberDocumentOfClient}
                        validateInputOfSearch={validateInputOfSearch}
                        formRef={searchFormRef}
                    />
                </div>
                <div className="col-12">
                    <LineCrudTableForm 
                        createData={createData} 
                        updateData={updateData} 
                        handleReset={handleReset}
                        setDataToEdit={setDataToEdit} 
                        form={form} 
                        initialForm={initialForm} 
                        setForm={setForm}
                        errors={errors}/>
                </div>
                <div className="col-12">
                    {loading && <SpinnerBootrap/>}
                    {lines && 
                    <LineCrudTable 
                        lines={lines} 
                        editData={editData} 
                        deleteData={deleteData}
                        listLines={listLines}
                        handleShow={handleShow}
                        setFindModal={setFindModal}
                        setIdforLine={setIdforLine}
                        listClientsAll={getAmountClientsWhitoutLine}
                        listClientsByNumberLine={listClientsByNumberLine}
                        amountPages={amountLinesPages}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        resetSearch={resetSearch}
                        hasSearched={hasSearch}
                    />}
                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Clientes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {
                        <LineCrudTableSearchModal
                            setFindModal = {setFindModal}
                            listClientsByNumDocument={listClientsByNumDocument}
                            listClientsByMail={listClientsByMail}
                            listClientsByName={listClientsByName}
                            validateInputOfSearch={validateInputOfSearch}
                            />}
                    </div>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {clients && ListClientsWhitLine &&
                        <LineCrudTableModal
                            clients={clients} 
                            listClientsWhitoutLine={listClientsWhitoutLine}
                            getAmountClientsWhitoutLine={getAmountClientsWhitoutLine}
                            ListClientsWhitLine={ListClientsWhitLine}
                            openModalVinculetedAlreadyExists={openModalVinculetedAlreadyExists}
                            vinculedClient={vinculedClient}
                            listClientsAll={getAmountClientsWhitoutLine}
                            amountClientsPages = {amountClientsPages}
                            numberPageClient={numberPageClient}
                            />}
                    </div>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {ListClientsWhitLine && 
                        <LineCrudTableModal2
                            ListClientsWhitLine={ListClientsWhitLine} 
                            //ListClientsWhitLine={ListClientsWhitLine}
                            desvinculedClient={desvinculedClient}
                            />}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
export default LineCrud;
